module.exports = __webpack_public_path__ + "static/media/google_signin_button.1cdc8fce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/google_signin_button.svg
// module id = 867
// module chunks = 0